export const FIELD_SWITCH = "switch";
export const FIELD_SELECT = "select";
export const FIELD_TABLE = "table";